import React from "react"
import { AsyncCreatable } from "react-select"

import SelectTags from "../../../common/tags/SelectTags"

const CommunityEditLabels = ({
    labels,
    systemLabels,
    onValueChange,
    onLabelsSearch
}) => (
    <div className="widget">
        <div className="widget-content">
            <h3 className="first-heading">
                <span className="icon icon-status" />Labels
            </h3>
            <div>
                <SelectTags
                    name="labels"
                    value={labels}
                    SelectComponent={AsyncCreatable}
                    loadOptions={onLabelsSearch}
                    placeholder="Labels"
                    autoload={true}
                    onChange={onValueChange("labels")}
                />
            </div>
            <h3>
                <span className="icon icon-status" />System Labels
            </h3>
            <div className="tags">
                {systemLabels.map(label => (
                    <div key={label} className="tag-item grey">
                        {label}
                    </div>
                ))}
                {(!systemLabels || systemLabels.length <= 0) && "No labels"}
            </div>
        </div>
    </div>
)

export default CommunityEditLabels
